import TemplateView from "../../../TemplateView";
import {UserManagementConstants} from "../../../constants";
import messageResource from "../../../messageResource";
import ListSelector from "../../../controls/ListSelector";
import $ from "jquery";
import ScrollUtils from "../../../util/ScrollUtils";

export default class Overtime extends  TemplateView {

    constructor($containerEl, id) {
        super($containerEl);
        this.id = id;
        this.state = {
            overtimeLevel: UserManagementConstants.OVERTIME_OFF,
            readOnly: false,
        };

        this.onStatePropertyChanged("overtimeLevel", (level) => {
            this._setOvertimeLevel(level)
        })

        this.onStatePropertyChanged('readOnly', readOnly => {
            this.$overtimeSelectorLabel.toggle(readOnly)

            if (!readOnly)
                this.overtimeSelector.show()
            else
                this.overtimeSelector.hide()
        })
    }

    templateHtml() {
        return "<div class='scheduleOvertimeTable'>" +
               "    <div><%=overtime%></div>" +
               "    <div class='overtimeSelectorPlaceholder'></div>" +
               "    <div class='overtimeSelectorLabel'></div>" +
               "</div>";
    }

    messageKeys() {
        return {
            overtime: 'userlist.userdata.schedule.overtime'
        }
    }

    afterRender() {
        this.overtimeSelector = this.createOvertimeSelector(this.state.overtimeLevel, this.find(".overtimeSelectorPlaceholder")[0]);
        this.$overtimeSelectorLabel = this.find('.overtimeSelectorLabel')
        this.renderInitialState()
    }

    createOvertimeSelector( userOvertimeValue, renderTo) {
        var defaultLevel = window.SystemSettings.defaultOvertimeLevel;
        var defaultLevelExpl = " " + messageResource.getMessage("userlist.js.overtime_selector.default");
        this.listItems = [
            {
                text: messageResource.getMessage("userlist.js.overtime_off") + (defaultLevel == UserManagementConstants.OVERTIME_OFF ? defaultLevelExpl: ""),
                value: UserManagementConstants.OVERTIME_OFF
            },
            {
                text: messageResource.getMessage("userlist.js.overtime_auto_hidden") + (defaultLevel == UserManagementConstants.OVERTIME_AUTO_HIDDEN ? defaultLevelExpl: ""),
                value: UserManagementConstants.OVERTIME_AUTO_HIDDEN
            },
            {
                text: messageResource.getMessage("userlist.js.overtime_auto") + (defaultLevel == UserManagementConstants.OVERTIME_AUTO ? defaultLevelExpl: ""),
                value: UserManagementConstants.OVERTIME_AUTO
            },
            {
                text: messageResource.getMessage("userlist.js.overtime_manual") + (defaultLevel == UserManagementConstants.OVERTIME_MANUAL ? defaultLevelExpl: ""),
                value: UserManagementConstants.OVERTIME_MANUAL
            }
        ];

        var selector = new ListSelector({
            menuCls: "overtimeSelectorMenu",
            renderTo: renderTo,
            value: userOvertimeValue,
            listItems: this.listItems,
            scrollableContainer: this.$containerEl[0],
            listeners: {
                menushow: function(button, menu) {
                    $(menu.el.dom).on(
                        ScrollUtils.getWheelEventName(),
                        function(e) {
                            e.preventDefault();
                        }
                    );
                }
            }
        });

        var self = this;
        selector.on("change", function( context, item ) {
            if (self.state.overtimeLevel !== item.value) {
                self.setState({overtimeLevel: item.value});
                self.trigger("changeOvertime", [item.value]);
            }
        });

        return selector;
    };

    getElementBySubId(name) {
        return document.getElementById( this.id + "_" + name );
    }

    hideOpenedExtJSSelector() {
        this.overtimeSelector.hideMenuOnScrollOrResize();
    }

    _setOvertimeLevel(level) {
        this.overtimeSelector.setItem(this.overtimeSelector.getItemByValue(level))
        this.$overtimeSelectorLabel.html(this.listItems.find(item => item.value === level).text)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/Overtime.js